import React from 'react'

export const Legal: React.FC = () => {
  return (
    <section className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">
            Legal Disclaimers & <span className="text-blue-600">Guarantee</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Money-Back Guarantee */}
          <div className="bg-green-50 border border-green-200 rounded-lg p-8">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mr-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-green-800">60-Day Money-Back Guarantee</h3>
            </div>
            
            <div className="text-green-700 space-y-4">
              <p className="font-semibold">
                We stand behind our guide with a comprehensive 60-day guarantee:
              </p>
              
              <ul className="space-y-2 text-sm">
                <li className="flex items-start">
                  <svg className="w-4 h-4 text-green-600 mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  If you follow our strategies and don't see progress within 60 days, get a full refund
                </li>
                <li className="flex items-start">
                  <svg className="w-4 h-4 text-green-600 mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  No questions asked - we'll process your refund within 48 hours
                </li>
                <li className="flex items-start">
                  <svg className="w-4 h-4 text-green-600 mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Keep all bonus materials as our gift, even if you request a refund
                </li>
                <li className="flex items-start">
                  <svg className="w-4 h-4 text-green-600 mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Contact support at any time during the 60-day period
                </li>
              </ul>
              
              <div className="bg-green-100 border border-green-300 rounded-lg p-4 mt-6">
                <p className="text-green-800 font-medium text-sm">
                  📞 <strong>Guarantee Contact:</strong> support@ailegalmedia.com
                </p>
              </div>
            </div>
          </div>

          {/* Legal Disclaimers */}
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-8">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mr-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Important Legal Information</h3>
            </div>
            
            <div className="text-gray-700 space-y-4 text-sm">
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Educational Purpose</h4>
                <p>
                  This guide is for educational purposes only and does not constitute legal advice. 
                  While our strategies are based on established consumer protection laws and documented legal principles, 
                  you should consult with a qualified attorney if you have specific legal questions.
                </p>
              </div>
              
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Results Disclaimer</h4>
                <p>
                  Individual results may vary based on specific circumstances, state laws, timeshare company policies, 
                  and how closely you follow our recommended strategies. Past success stories do not guarantee future results.
                </p>
              </div>
              
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">No Attorney-Client Relationship</h4>
                <p>
                  Purchase of this guide does not create an attorney-client relationship. We provide educational materials 
                  and email support for guidance, but cannot provide individual legal advice or representation.
                </p>
              </div>
              
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Compliance</h4>
                <p>
                  All strategies outlined in our guide are based on legitimate consumer protection laws and legal principles. 
                  We do not advocate for any illegal activities or unethical practices.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <div className="mt-12 bg-blue-50 border border-blue-200 rounded-lg p-8">
          <h3 className="text-xl font-bold text-blue-900 mb-6 text-center">
            Contact Information
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div>
              <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-3">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h4 className="font-semibold text-blue-900 mb-1">Email Support</h4>
              <p className="text-blue-700 text-sm">support@ailegalmedia.com</p>
              <p className="text-blue-600 text-xs">Response within 24 hours</p>
            </div>
            
            <div>
              <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-3">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9v-9m0-9v9" />
                </svg>
              </div>
              <h4 className="font-semibold text-blue-900 mb-1">Website</h4>
              <p className="text-blue-700 text-sm">www.ailegalmedia.com</p>
              <p className="text-blue-600 text-xs">Resources & Updates</p>
            </div>
            
            <div>
              <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-3">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h4 className="font-semibold text-blue-900 mb-1">Business Address</h4>
              <p className="text-blue-700 text-sm">AI Legal Media LLC</p>
              <p className="text-blue-600 text-xs">Legal entity information</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}